module.exports = __webpack_public_path__ + "img/garden of the sun.d5f1174a.png";